import React from 'react';
import { Typography } from '@material-ui/core';
import Stack from '@mui/material/Stack';

export const About2 = () => {
  return (
    <div className="about-main-container">
      <div className="about-cover about-2-image" />
      <div className="container">
        <Stack spacing={3} className="about-stack about-2-stack">
          <div className="about-title">
            You also know that social media is pretty much the same
          </div>
          <Typography className="about-description">
            It’s basically broken too, at least for people who post. Did you
            know Instagram’s algorithm is literally designed to show your posts
            to less than 10% of your followers, on average?
          </Typography>
          <Typography className="about-footer">
            That’s not fair… and it’s why musicians are currently abandoning
            social media.
          </Typography>
        </Stack>
      </div>
    </div>
  );
};
